import HtmlEditor from '@intercom/embercom-composer/components/html-editor';
export default HtmlEditor;
